import React, { useContext, useMemo } from "react";

import ContentEncoder from "./ContentEncoder";
import TabsMaster from "./TabsMaster";
import ContentContext from "../../contexts/ContentContext";
import MasterMediaContext from "../../contexts/MasterMediaContext";

import type { ContentContextValues } from "./ContentTabs";
import type { MediaChildren } from "../../api/MediaAPI.types";

function ContentMasterWithContext() {
  const { item: masterItem } = useContext<ContentContextValues>(ContentContext);

  const { activeTab } = useContext(MasterMediaContext);

  const childByIds = useMemo(
    () =>
      masterItem.children?.reduce<Record<string, MediaChildren>>(
        (acc, child) => {
          acc[child.uuid] = child;
          return acc;
        },
        {},
      ),
    [masterItem.children],
  );

  const item = childByIds?.[activeTab];

  if (!item) return null;

  return (
    <div className="flex w-full min-w-0 flex-1 flex-col gap-12">
      <ContentEncoder key={item.uuid} item={item} />
    </div>
  );
}

export default function ContentMaster(): React.JSX.Element {
  return (
    <TabsMaster>
      <ContentMasterWithContext />
    </TabsMaster>
  );
}
